export const filterByDepartment = (
  items: any[],
  department: string,
  departmentId: string
) => {
  const allDeptIndex = items.findIndex(
    (item: any) => item.department === "All Dept"
  );

  items.push(...items.splice(0, allDeptIndex));

  const filtertedItems = items.filter((item: any) => {
    if (department === "all") return true;

    return departmentId === item.id;
  });
  return filtertedItems.length ? filtertedItems : null;
};

type DepartmentMapper = {
  [key: string]: string;
};

export const departmentMapper: DepartmentMapper = {
  Total: "All Dept",
  "Fresh Meat": "Meat"
};

export const filterAndMapWithUniqueValue = (
  data: any,
  id: string,
  name: string
) => {
  const uniqueData = [] as any;
  return data
    ?.filter((item: any) => {
      if (item?.[id] && !uniqueData?.includes(item?.[id])) {
        uniqueData.push(item?.[id]);
        return item;
      }
    })
    ?.map((item: any) => ({ id: item?.[id], name: item?.[name] }));
};
